import Immutable from "immutable";
import { COLLECTION_SHAPE } from "../../../config/shapes";
import { CLEAR_CABIN_CREW_FOR_SCHEDULING, GET_CABIN_CREW_FOR_SCHEDULING, LOAD_CABIN_CREW_FOR_SCHEDULING } from "../../../actions/types";

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
})

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case LOAD_CABIN_CREW_FOR_SCHEDULING:
      return state.setIn(['all', 'loading'], payload);
    case GET_CABIN_CREW_FOR_SCHEDULING:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_CABIN_CREW_FOR_SCHEDULING:
      return INITIAL_STATE;
    default:
      return state;
  }
};